import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'

// 本地的文件夹

import viLocale from './pack/vi'
import zhLocale from './pack/zn'



// vant中的文件夹  需要的语言和本地的语言保持一致

import {
  TokenLangKey,
  getTokenbyName,
  // setTokenbyName
} from "@/utils/cookies";

Vue.use(VueI18n)

const messages = {
  'vi': {
    ...viLocale
  },
  'zh': {
    ...zhLocale
  }
}
// localStorage获取当前语言类型(初次本地不存在'lang'字段存储，默认设置为'zh_CN')
let lang = getTokenbyName(TokenLangKey) // ''zh''
if (!(lang && lang.length > 0)) {
    lang = 'en'
}
lang = 'zh'
// 初次加载的语言默认设置
Locale.use(lang, messages[lang])
export default new VueI18n({
  locale: lang, // set locale
  messages: messages // set locale messages
})
